import { createI18n } from "vue-i18n";

const modulesFiles = require.context("./temp", true, /\.json$/);
let messages = { en: {}, zh: {}, th: {} };
modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath);
  const { en, zh, th } = value;
  messages.en = { ...messages.en, ...en };
  messages.th = { ...messages.th, ...th };
  messages.zh = { ...messages.zh, ...zh };
}, {});

let locale = "zh";
if (localStorage.getItem("ktr_lang")) {
  if (localStorage.getItem("ktr_lang") === "zh") {
    locale = "zh";
  } else if (localStorage.getItem("ktr_lang") === "th") {
    locale = "th";
  } else if (localStorage.getItem("ktr_lang") === "en") {
    locale = "en";
  }
}

const i18n = createI18n({
  locale, // 设置语言类型
  legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
  globalInjection: true, // 全局注册$t方法
  messages,
  isOnlineTrans: true,
});

export default i18n;
